export const packages = {
	title: "Paquetes",
	header: {
		title: "Agregar saldo",
		subtitle: "Agregue saldo para enviar mensajes a sus clientes",
	},
	modalPackage: {
		title: "Comprar paquete",
		label: "¿Desea comprar el Paquete",
		for: "por",
		addBalance: "y agregar {{amount}} sms de saldo?",
		footer: {
			sellPackage: "Comprar paquete de SMS",
		},
	},
	packageCard: {
		tagLabel: "Tag Label",
		sms: "SMS",
		forSMS: "por SMS",
		sell: "Comprar paquete",
	},
	xlsx: {
		title: "Historial de Campañas de SMS",
		filename: "campanas-sms",
		message: "Mensaje",
		place: "Local",
		date: "Fecha y hora",
		status: "Estado",
		impactedCustomers: "Clientes impactados",
	},
};
